import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { useForm } from "react-hook-form";
import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import clsx from "clsx";
import { useCallback, useEffect, useRef, useState } from "react";
import SearchableSelectMenu from "@/app/components/ui/SelectMenus/SearchableSelectMenu";
import { FiUploadCloud } from "react-icons/fi";
import { useSelectMenuReducer } from "@/app/hooks/useSelectMenuReducer";
import { useRouter } from "@/app/hooks/useRouter";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { useDocumentUploadAPI } from "@/app/hooks/api_hooks/CertificateDocument/useDocumentUploadAPI";
import { ICertificatesDocumentUploadPostBody } from "@/api_framework/api_modals/Certificates";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { ROUTES } from "@/app/routes";
import { useFileToS3LinkGeneratorAPI } from "@/app/hooks/api_hooks/LabReport/useFileToS3LinkGeneratorAPI";
import { toast } from "react-hot-toast";
import { useDocumentListAPI } from "@/app/hooks/api_hooks/CertificateDocument/useDocumentListAPI";
import { IoCamera } from "react-icons/io5";
import { MdOutlineFlipCameraIos } from "react-icons/md";
import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { useModal } from "@/app/hooks/ui_hooks/useModal";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import UserPetDetailsComponent from "@/app/components/ui/Reusable/UserPetDetailsComponent";

const certificates = [
  { id: "1", title: "Job Card", sub: "Report" },
  { id: "2", title: "Patient Document", sub: "Report" },
  { id: "3", title: "General Consent Form", sub: "" },
  { id: "4", title: "X-RAY", sub: "" },
  { id: "5", title: "ULTRASOUND", sub: "ULTRASOUND" },
  { id: "6", title: "Feline Immunodeficiency Virus / Feline Leukemia Virus Antigen Test", sub: "Report" },
  { id: "7", title: "Canine Parvo-Corona-Giardia Antigen Kit test", sub: "Report" },
  { id: "8", title: "Ehrlichia-Anaplasa-Babesia-Heartworm Antibody Kit test", sub: "Report" },
  { id: "9", title: "Canine Distemper-Parvo-Corona-Giardia Combo Rapid test", sub: "Report" },
  { id: "10", title: "Feline Panleukopenia-Feline Corona-Giardia Kit test", sub: "Report" },
  { id: "11", title: "Canine Parvo", sub: "Report" },
  { id: "12", title: "Canine Parvo Distemper", sub: "Report" },
  { id: "13", title: "Feline Infectious Peritonitis Antibody Test", sub: "Report" },
  { id: "14", title: "Feline Panleukopenia Antigen Test Kit", sub: "Report" },
  { id: "15", title: "Death Certificate", sub: "Report" },
  { id: "16", title: "EUTHANASIA CONSENT FORM", sub: "Report" },
  { id: "17", title: "FREEDOM FROM DISEASE DECLARATION", sub: "Report" },
  { id: "18", title: "PET HEALTH CUM TRAVEL CERTIFICATE", sub: "Report" },
  { id: "19", title: "MICROCHIPPING CERTIFICATE", sub: "Report" },
  { id: "20", title: "PET VACCINATION CERTIFICATE", sub: "Report" },
  { id: "21", title: "CERTIFICATE OF STERILIZATION", sub: "Report" },
  { id: "22", title: "Boarding and Hospitalisation Agreement", sub: "Report" },
  { id: "23", title: "PET HEALTH CERTIFICATE", sub: "Report" },
  { id: "24", title: "Sedation, or Anaesthesia and Surgery Consent Form", sub: "Report" },
  { id: "25", title: "X-Ray/USG Consent Form", sub: "Report" },
  { id: "26", title: "Blood glucose", sub: "Report" },
  { id: "27", title: "Urine Routine Analysis", sub: "Report" },
  { id: "28", title: "Ear Swab for Mite", sub: "Report" },
  { id: "29", title: "BP measurement", sub: "Report" },
  { id: "30", title: "Skin Scraping Microscopic", sub: "Report" },
  { id: "31", title: "ECHOCARDIOGRAPHY", sub: "Report" },
  { id: "34", title: "Rabies Titre", sub: "Report" },
  { id: "35", title: "Cytology", sub: "Report" },
  { id: "36", title: "FNAC / HISTOPATHOLOGY / BIOPSY", sub: "Report" },
  { id: "37", title: "Fungal Staining", sub: "Report" },
  { id: "38", title: "Surgical Estimates_blue7", sub: "Report" },
  { id: "39", title: "Pre Anaesthetic Estimates_blue7", sub: "Report" },
  { id: "40", title: "Procedure Estimates_blue7", sub: "Report" },
];

export interface ICertificateDocumentUploadModalProps {
  documents?: string[];
  pet_name: string;
  pet_id: string;
  certificate_type: string;
  certificate_id: string;
  remarks: string;
  clinic_id: string;
  customer_id: string;
}

export const compressImageWithoutLib = async (file: File): Promise<File> => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target?.result as string;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // scale down (example: 50% size)
        const MAX_WIDTH = 800; // you can tune this
        const scale = Math.min(1, MAX_WIDTH / img.width);

        canvas.width = img.width * scale;
        canvas.height = img.height * scale;

        ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);

        // compress to JPEG with quality (0.7 = 70%)
        canvas.toBlob(
          (blob) => {
            if (blob) {
              const compressedFile = new File([blob], file.name, {
                type: "image/jpeg",
                lastModified: Date.now(),
              });

              console.log(
                `Compressed: ${file.name}, Original: ${(file.size / 1024 / 1024).toFixed(2)} MB, Compressed: ${(compressedFile.size / 1024 / 1024).toFixed(2)} MB`,
              );

              resolve(compressedFile);
            }
          },
          "image/jpeg",
          0.7, // adjust quality here
        );
      };
    };
  });
};

const CertificateDocumentUploadModalContent = ({
  formHook,
  setSelectedCertificate,
  documentData,
  hasDefaultSelectionContext,
  resetToken,
}) => {
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id"));
  const { customerPets } = routeState.state as ICustomerProfileState;
  const petItems = useSelectMenuReducer(customerPets, "name", "id", {
    stateKey: "status",
  });
  const { execute: uploadToS3 } = useFileToS3LinkGeneratorAPI();
  const [cameraAvailable, setCameraAvailable] = useState(false);
  const [showCamera, setShowCamera] = useState(false);
  const [_capturedImage, setCapturedImage] = useState<File | null>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [facingMode, setFacingMode] = useState<"user" | "environment">("environment");

  useEffect(() => {
    checkCameraAvailability().then(setCameraAvailable);
  }, []);

  const checkCameraAvailability = async (): Promise<boolean> => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      return devices.some((device) => device.kind === "videoinput");
    } catch (err) {
      console.error("Camera check failed:", err);
      return false;
    }
  };

  const stopCameraStream = () => {
    const video = videoRef.current;
    if (video && video.srcObject) {
      const stream = video.srcObject as MediaStream;
      stream.getTracks().forEach((track) => track.stop());
      video.srcObject = null;
    }
  };

  useEffect(() => {
    setUploadedFiles([]);
    setCapturedImage(null);
    setShowCamera(false);
    setFacingMode("environment");
    stopCameraStream();
  }, [resetToken]);

  useEffect(() => {
    if (showCamera && videoRef.current) {
      navigator.mediaDevices
        .getUserMedia({ video: { facingMode } })
        .then((stream) => {
          if (videoRef.current) {
            videoRef.current.srcObject = stream;
          }
        })
        .catch((err) => {
          toast.error("Unable to access camera");
          console.error(err);
          setShowCamera(false);
        });
    }
  }, [showCamera, facingMode]);

  // Convert HEIC to JPEG using canvas
  const convertHeicToJpeg = async (file: File): Promise<File> => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const img = new Image();
        img.src = e.target?.result as string;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx?.drawImage(img, 0, 0);

          canvas.toBlob(
            (blob) => {
              if (blob) {
                const jpegFile = new File([blob], file.name.replace(/\.[^/.]+$/, ".jpg"), {
                  type: "image/jpeg",
                  lastModified: Date.now(),
                });
                console.log(
                  `Converted HEIC -> JPEG: ${jpegFile.name}, Size: ${(jpegFile.size / 1024 / 1024).toFixed(2)} MB`,
                );
                resolve(jpegFile);
              }
            },
            "image/jpeg",
            0.9,
          );
        };
      };
      reader.readAsDataURL(file);
    });
  };

  const MAX_FILE_SIZE_MB = 10;

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target;
    const files = input.files ? Array.from(input.files) : [];
    input.value = "";

    const certificateId = formHook.getValues("certificate_id");
    if (!certificateId) {
      toast.error("Please select certificate before uploading document.");
      return;
    }

    if (files.length > 0) {
      const allowedTypes = ["image/jpeg", "image/png", "application/pdf", "image/heic", "image/heif"];
      const invalidFiles = files.filter((file) => !allowedTypes.includes(file.type));
      if (invalidFiles.length > 0) {
        toast.error("Only JPG, PNG, HEIC/HEIF and PDF files are allowed.");
        return;
      }

      const oversizedFiles = files.filter((file) => file.size / 1024 / 1024 > MAX_FILE_SIZE_MB);
      if (oversizedFiles.length > 0) {
        toast.error(`File size must be less than ${MAX_FILE_SIZE_MB} MB.`);
        return;
      }

      const existingFiles = uploadedFiles.map((f) => `${f.name}-${f.size}`);
      const uniqueFiles = files.filter((file) => {
        const key = `${file.name}-${file.size}`;
        if (existingFiles.includes(key)) {
          toast.error(`File "${file.name}" is already uploaded.`);
          return false;
        }
        return true;
      });

      if (uniqueFiles.length === 0) return;

      const processedFiles = await Promise.all(
        uniqueFiles.map(async (file) => {
          if (file.type === "image/heic" || file.type === "image/heif") {
            return await convertHeicToJpeg(file);
          }
          if (file.type.startsWith("image/")) {
            return await compressImageWithoutLib(file);
          }
          return file;
        }),
      );

      const uploadedImages = await Promise.all(
        processedFiles.map(async (file) => {
          const result = await uploadToS3(file, formHook.getValues("certificate_id"), "certificate");
          if (result.status) {
            return result.message;
          }
          toast.error(`Failed to upload ${file.name}`);
          return null;
        }),
      );

      const validImages = uploadedImages.filter((img) => img !== null);
      const currentImages = formHook.getValues("documents") || [];
      formHook.setValue("documents", [...currentImages, ...new Set(validImages?.flat())]);
      setUploadedFiles([...uploadedFiles, ...uniqueFiles]);
    }
  };

  const handleCapture = async () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    if (video && canvas) {
      const ctx = canvas.getContext("2d");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      ctx?.drawImage(video, 0, 0, canvas.width, canvas.height);

      canvas.toBlob(async (blob) => {
        if (blob) {
          const originalFile = new File([blob], `photo-${Date.now()}.jpg`, {
            type: "image/jpeg",
          });
          const compressedFile = await compressImageWithoutLib(originalFile);
          console.log(
            `Photo captured: ${compressedFile.name}, Size: ${(compressedFile.size / 1024 / 1024).toFixed(2)} MB`,
          );
          setCapturedImage(compressedFile);
          handleFileChange({ target: { files: [compressedFile] } } as any);
          stopCameraStream();
          setShowCamera(false);
        }
      }, "image/jpeg");
    }
  };

  return (
    <div>
      <div className="px-2">
        <UserPetDetailsComponent petDetails={documentData?.pet_details} userDetails={documentData?.user_details} />
      </div>
      <div className="items-center sm:gap-16 sm:flex mt-3">
        <div className="flex justify-start items-center gap-1 p-2.5 w-[150px] shrink-0">
          <span className="font-normal text-black text-xs">Select Certificate</span>
          <span className="font-normal text-rose-600 text-xs">*</span>
        </div>
        <div className="w-full sm:w-72">
          {hasDefaultSelectionContext && documentData?.pet_details?.name ? (
            <p> {documentData?.document_types?.length > 0 && documentData?.document_types[0]}</p>
          ) : (
            <>
              {" "}
              <SearchableSelectMenu
                errorMessages={[{ message: "Certificate is required", type: "required" }]}
                onSelectItem={(item) => {
                  if (item) {
                    formHook.setValue("certificate_type", item.title);
                    formHook.setValue("certificate_id", item.id);
                    setSelectedCertificate(item.title);
                  }
                }}
                fieldError={formHook.formState.errors.certificate_type}
                register={formHook.register("certificate_type", { required: true })}
                selectItems={certificates}
                placeholder="Select Certificate"
                showTooltips={true}
                showTypedErrors={false}
                showDropdownIcon={true}
                defaultSelected={certificates?.find((oc) => oc.title === formHook.watch("certificate_type"))}
                listBoxClassName="w-full"
                className="text-gray-800 w-full"
              />
              {formHook.formState.errors.certificate_type && (
                <p className="text-red-600 text-xs mt-1">Please select a certificate</p>
              )}
            </>
          )}
        </div>
      </div>
      <div className="items-center sm:gap-16 sm:flex mt-5">
        <div className="flex justify-start items-center gap-1 p-2.5 w-[150px] shrink-0">
          <span className="font-normal text-black text-xs">Select Pet</span>
          <span className="font-normal text-rose-600 text-xs">*</span>
        </div>
        <div className="w-full sm:w-72">
          {hasDefaultSelectionContext && documentData?.pet_details?.name ? (
            <p>{documentData?.pet_details?.name}</p>
          ) : (
            <SearchableSelectMenu
              errorMessages={[{ message: "Pet is required", type: "required" }]}
              onSelectItem={(item) => {
                if (item) {
                  formHook.setValue("pet_name", item.title);
                  formHook.setValue("pet_id", item.id);
                }
              }}
              fieldError={formHook.formState.errors.pet_name}
              register={formHook.register("pet_name", { required: true })}
              selectItems={petItems}
              placeholder="Select Pet"
              showTooltips={true}
              showTypedErrors={false}
              showDropdownIcon={true}
              defaultSelected={petItems?.find((oc) => oc.id === formHook.watch("pet_id"))}
              listBoxClassName="w-full"
              className="text-gray-800 w-full"
            />
          )}
          {formHook.formState.errors.pet_name && <p className="text-red-600 text-xs mt-1">Please select a pet</p>}
        </div>
      </div>
      <div className="justify-start items-center sm:gap-16 sm:flex mt-5 mb-5">
        <div className="flex justify-start items-center gap-1 p-2.5 w-[150px] shrink-0">
          <span className="font-normal text-black text-xs">Add Remarks</span>
        </div>
        <div className="w-full sm:w-72">
          <textarea
            style={{
              overflowY: "scroll",
              scrollbarWidth: "thin",
            }}
            rows={3}
            className={clsx(`rounded-md w-full h-full border-gray-300 text-xs `)}
            placeholder="Add Remarks"
            {...formHook.register(`remarks`, { required: false })}
          />
        </div>
      </div>
      <div className="justify-start items-center sm:gap-16 sm:flex mb-5">
        <div className="flex justify-start items-center gap-1 p-2.5 w-[150px] shrink-0">
          <span className="font-normal text-black text-xs">Document</span>
        </div>
        <div className="w-full sm:w-72">
          <div
            className="flex gap-2 items-baseline border border-gray-300 py-3 px-4 sm:px-10 rounded-md justify-center cursor-pointer"
            onClick={() => document.getElementById("signed-doc-upload")?.click()}
          >
            <FiUploadCloud size="15" />
            <p className="text-xs font-semibold text-[#1364ff] cursor-pointer">Upload Signed Document</p>
            <input
              type="file"
              id="signed-doc-upload"
              className="hidden"
              multiple
              accept=".png,.jpeg,.jpg,.pdf,.heic,.heif"
              onChange={handleFileChange}
            />
          </div>
          <div className="text-center py-2 text-xs">OR</div>
          {cameraAvailable && (
            <div
              className="flex gap-2 items-center border border-gray-300 py-3 px-4 sm:px-10 rounded-md justify-center cursor-pointer"
              onClick={() => setShowCamera(true)}
            >
              <IoCamera />
              <p className="text-xs font-semibold text-[#1364ff] cursor-pointer">Take Photo</p>
            </div>
          )}
        </div>
      </div>
      {showCamera && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-90 flex flex-col justify-between sm:px-10 sm:pt-10 sm:pb-24 md:px-3 md:pt-3 md:pb-24 items-center pb-3 pt-3 px-3">
          <button
            onClick={() => {
              stopCameraStream();
              setShowCamera(false);
            }}
            className="absolute top-4 right-4 text-white text-2xl font-bold z-10"
            aria-label="Close camera"
          >
            &times;
          </button>
          <video ref={videoRef} autoPlay playsInline className="w-full h-full object-cover" />
          <canvas ref={canvasRef} style={{ display: "none" }} />
          <div className="w-full p-4 bg-black flex justify-center items-center gap-6">
            {navigator?.userAgent?.match(/Mobi|Android|iPhone|iPad/i) && (
              <button
                onClick={() => {
                  stopCameraStream();
                  setFacingMode((prev) => (prev === "user" ? "environment" : "user"));
                }}
                className="text-white text-sm px-3 py-1 items-center rounded sm:text-[20px] md:text-[30px] text-[30px]"
              >
                <MdOutlineFlipCameraIos color="white" />
              </button>
            )}
            <button
              className="sm:w-16 sm:h-16 w-20 h-20 bg-white rounded-full border-4 border-gray-400 shadow-md flex items-center justify-center"
              onClick={handleCapture}
            >
              <div className="w-10 h-10 bg-gray-200 rounded-full" />
            </button>
          </div>
        </div>
      )}
      {uploadedFiles.length > 0 && (
        <div className="mt-5 flex gap-4 w-full overflow-x-auto border border-gray-200 rounded-lg p-3">
          {uploadedFiles.map((file, idx) => {
            const isImage = file.type.startsWith("image/");
            const fileURL = URL.createObjectURL(file);
            return (
              <div key={idx} className="relative shrink-0">
                {isImage ? (
                  <div className="w-24">
                    <img
                      src={fileURL}
                      alt={`upload-${idx}`}
                      className="w-24 h-24 object-cover rounded border border-gray-300"
                    />
                    <p className="text-xs text-gray-800 px-2 py-1">{file.name}</p>
                    <button
                      type="button"
                      onClick={() => {
                        const newFiles = uploadedFiles.filter((_, index) => index !== idx);
                        setUploadedFiles(newFiles);
                        formHook.setValue("documents", newFiles);
                      }}
                      className="absolute top-[-5px] right-[-8px] bg-white border border-gray-300 rounded-full w-5 h-5 text-xs flex items-center justify-center hover:bg-gray-100"
                      aria-label="Remove file"
                    >
                      ×
                    </button>
                  </div>
                ) : (
                  <div className="flex flex-col items-center w-24 relative overflow-hidden">
                    <img
                      src={"https://vetic-img.s3.ap-south-1.amazonaws.com/quick_commerce//misc/pdf-svgrepo-com.svg"}
                      alt={"pdfs"}
                      className="w-full h-full object-cover"
                    />
                    <p className="text-xs text-gray-800 px-2 py-1">{file.name}</p>
                    <button
                      type="button"
                      onClick={() => {
                        const newFiles = uploadedFiles.filter((_, index) => index !== idx);
                        setUploadedFiles(newFiles);
                        formHook.setValue("documents", newFiles);
                      }}
                      className="absolute top-[-6px] right-[-3px] bg-white border border-gray-300 rounded-full w-5 h-5 mt-1 text-xs hover:bg-gray-100"
                    >
                      x
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

const CertificateDocumentUploadModal = () => {
  const configuration = useConfiguration();
  const { setInvisible, setModalData } = useModalActions("CERTIFICATE_DOCUMENT_UPLOAD_MODAL");
  const isUploadModalVisible = useModal("CERTIFICATE_DOCUMENT_UPLOAD_MODAL");
  const documentData = useModalState("CERTIFICATE_DOCUMENT_UPLOAD_MODAL");
  const { execute: uploadCertificate } = useDocumentUploadAPI();
  const clinicId = localStorage.getItem(configuration.localStorage.CLINIC.key);
  const { mappedClinicId } = useAppSelector((state) => state.root.UIStates);
  const { routeState } = useRouteInfo(ROUTES.ROOT.children.CUSTOMER_PROFILE.id);
  const { customerId } = routeState.state as ICustomerProfileState;
  const { execute: fetchDocumentList } = useDocumentListAPI();
  const [_selectedCertificate, setSelectedCertificate] = useState<string | null>(null);
  const [isUploading, setIsUploading] = useState(false);
  const [submitError, setSubmitError] = useState<string>("");
  const [resetToken, setResetToken] = useState(0);
  const previousVisibilityRef = useRef(false);
  const hasDefaultSelectionContext = Boolean(documentData?.booking_id || documentData?.source === "cart_job_card");

  const formHook = useForm<ICertificateDocumentUploadModalProps>({
    mode: "onChange",
    defaultValues: {
      pet_id: "",
      customer_id: "",
      pet_name: "",
      certificate_id: "",
      certificate_type: "",
      remarks: "",
      documents: [],
    },
  });

  const handleClose = () => {
    formHook.resetField("pet_id");
    formHook.resetField("pet_name");
    formHook.resetField("certificate_type");
    formHook.resetField("certificate_id");
    formHook.resetField("documents");
    formHook.resetField("remarks");
    setSubmitError("");
    setModalData({});
    setResetToken((prev) => prev + 1);
    setInvisible();
  };

  const resetModalState = useCallback(() => {
    formHook.reset({
      certificate_type: "",
      certificate_id: "",
      pet_name: "",
      pet_id: "",
      remarks: "",
      documents: [],
    });
    setSelectedCertificate("");
    setSubmitError("");
    setModalData({});
    setResetToken((prev) => prev + 1);
  }, [formHook, setModalData]);

  useEffect(() => {
    const wasVisible = previousVisibilityRef.current;
    if (wasVisible && !isUploadModalVisible) {
      resetModalState();
    }
    previousVisibilityRef.current = isUploadModalVisible;
  }, [isUploadModalVisible, resetModalState]);

  useEffect(() => {
    if (customerId) {
      formHook.setValue("customer_id", customerId);
    }
  }, [customerId]);

  useEffect(() => {
    if (clinicId) {
      formHook.setValue("clinic_id", clinicId);
    }
  }, [clinicId]);

  useEffect(() => {
    if (hasDefaultSelectionContext && documentData?.pet_details?.name) {
      formHook.setValue("pet_id", documentData?.pet_details?.id);
      formHook.setValue("pet_name", documentData?.pet_details?.name);
      formHook.setValue("customer_id", documentData?.user_details?.id);
      formHook.setValue("clinic_id", documentData?.clinic_details?.id);
      formHook.setValue("certificate_id", documentData?.document_types?.length > 0 && documentData?.document_types[0]);
    }
  }, [documentData, hasDefaultSelectionContext]);

  const handleSubmit = async (data: ICertificateDocumentUploadModalProps) => {
    if (isUploading) return;
    setSubmitError("");
    setIsUploading(true);
    const resolvedCustomerId =
      documentData?.user_details?.id || documentData?.customer_id || data?.customer_id || customerId;
    if (!resolvedCustomerId) {
      setSubmitError("Customer details missing.");
      setIsUploading(false);
      return;
    }
    const constructedBody: ICertificatesDocumentUploadPostBody = {
      customer_id: resolvedCustomerId,
      document_type: hasDefaultSelectionContext
        ? documentData?.document_types?.length > 0 && documentData?.document_types[0]
        : data?.certificate_type,
      pet_id: hasDefaultSelectionContext ? documentData?.pet_details?.id : data?.pet_id,
      clinic_id: mappedClinicId,
      remarks: data?.remarks,
      document_files: data.documents,
      booking_id: hasDefaultSelectionContext ? documentData?.booking_id : undefined,
    };
    try {
      const response = await uploadCertificate(constructedBody);
      const isSuccess = response?.status === true || String(response?.status).toLowerCase() === "true";
      if (isSuccess && documentData?.source === "cart_job_card") {
        window.dispatchEvent(
          new CustomEvent("cart:job-card-uploaded", {
            detail: {
              pet_id: documentData?.pet_details?.id,
            },
          }),
        );
      }
      if (!isSuccess) {
        setSubmitError(response?.message || "Failed to upload document. Please try again.");
        return;
      }
      if (documentData?.source === "cart_job_card" && typeof documentData?.onUploadSuccess === "function") {
        await documentData.onUploadSuccess();
      }
      resetModalState();
      setInvisible();
      if (customerId) {
        fetchDocumentList(customerId);
      }
    } catch (error) {
      console.error("Document upload failed:", error);
      setSubmitError("Failed to upload document. Please try again.");
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <ModalPrompt
      modalId="CERTIFICATE_DOCUMENT_UPLOAD_MODAL"
      showIcon={false}
      titleIcon=""
      dialogClassName="w-full sm:my-8 sm:w-full sm:max-w-2xl sm:p-6"
      button={{
        primaryButtonText: isUploading ? "Uploading..." : "Upload",
        secondaryButtonText: "Cancel",
        primaryButtonClassname: `px-6 py-[9px] rounded-md border border-slate-400 border-opacity-20 justify-center items-center gap-2 flex cursor-pointer bg-sky-900 hover`,
        primaryButtonDisabled:
          isUploading ||
          formHook.watch("pet_id")?.length == 0 ||
          formHook.watch("documents")?.length == 0 ||
          formHook.watch("certificate_id")?.length == 0,
        primaryCallback: () => {
          if (isUploading) return;
          handleSubmit(formHook.getValues());
        },
        secondaryCallback: () => {
          formHook.clearErrors();
          handleClose();
        },
      }}
      title="Upload Document"
      content={
        <div>
          <CertificateDocumentUploadModalContent
            formHook={formHook}
            setSelectedCertificate={setSelectedCertificate}
            documentData={documentData}
            hasDefaultSelectionContext={hasDefaultSelectionContext}
            resetToken={resetToken}
          />
          {submitError ? <p className="text-red-600 text-xs mt-4">{submitError}</p> : null}
        </div>
      }
    />
  );
};

export default CertificateDocumentUploadModal;
